import { Star } from "lucide-react";

/**
 * Inline star-rating display.
 * - rating: number (e.g., 4.3)
 * - size: lucide icon size
 */
const Stars = ({ rating = 0, size = 14, className = "" }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full;
        const isHalf = !filled && i === full && half;
        return (
          <Star
            key={i}
            size={size}
            className={
              filled || isHalf ? "text-amber-400" : "text-zinc-700"
            }
            fill={filled ? "currentColor" : isHalf ? "url(#half)" : "none"}
            strokeWidth={1.5}
          />
        );
      })}
    </div>
  );
};

export default Stars;
